import React from "react";
// Font Awesome imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";

const WhatsAppWidget: React.FC = () => (
  <a
    href="https://wa.me/256707442784"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: "fixed",
      bottom: "20px",
      right: "20px",
      backgroundColor: "#25D366",
      color: "white",
      borderRadius: "50%",
      width: "60px",
      height: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "28px",
      textDecoration: "none",
      boxShadow: "0 4px 8px rgba(0,0,0,0.3)"
    }}
  >
  <FontAwesomeIcon icon={faWhatsapp} size="lg" />
  </a>
);

export default WhatsAppWidget;
